import { Box, Step, StepLabel, Stepper } from "@mui/material";

export default function QuestionnaireStepper({
  questionnaire,
  currentQuestionnaire,
}: {
  questionnaire: any[];
  currentQuestionnaire: number;
}) {
  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box flex="0 0 15%" display="flex" justifyContent="flex-start">
        <img
          src="https://www.sp-akademie.de/wp-content/uploads/2024/11/Sprachportal-Akademie-GmbH.png"
          alt="Logo"
          style={{ height: 70, maxWidth: "100%" }}
        />
      </Box>

      <Box flex="0 0 85%">
        <Stepper activeStep={currentQuestionnaire} alternativeLabel>
          {questionnaire.map((label) => (
            <Step key={label.name}>
              <StepLabel>{label.name}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
}
